var SupportGPassStatusAndNotesPresentation;

SupportGPassStatusAndNotesPresentation = {
  editable: {
    status: "Awaiting seating information",
    notes: "We'll make seating information available at least 24 hours before the event. You'll be able to print your G-Pass as soon as you receive the information."
  },
  not_editable: {
    purchased: {
      status: "Awaiting seating information",
      notes: "We'll make seating information available at least 24 hours before the event. You'll be able to print your G-Pass once you receive the information."
    },
    available: {
      status: "Ready to print",
      notes: "You can find your seating information on your G-pass. You'll be able to bypass will-call when you arrive at the event."
    },
    redeemed: {
      status: "Event has passed",
      notes: ""
    },
    expired: {
      status: "Event has passed",
      notes: ""
    },
    expired_unredeemed: {
      status: "Event has passed",
      notes: ""
    },
    expired_redeemed: {
      status: "Event has passed",
      notes: ""
    }
  }
};

module.exports = SupportGPassStatusAndNotesPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9ncGFzc19tZXNzYWdlcy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC9wcmVzZW50ZXJzL2dwYXNzX21lc3NhZ2VzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLHNDQUFBLEdBQ0M7RUFBQSxRQUFBLEVBQ0M7SUFBQSxNQUFBLEVBQVEsOEJBQVI7SUFDQSxLQUFBLEVBQU8sMEpBRFA7R0FERDtFQUdBLFlBQUEsRUFDQztJQUFBLFNBQUEsRUFDQztNQUFBLE1BQUEsRUFBTyw4QkFBUDtNQUNBLEtBQUEsRUFBTyxvSkFEUDtLQUREO0lBR0EsU0FBQSxFQUNDO01BQUEsTUFBQSxFQUFRLGdCQUFSO01BQ0EsS0FBQSxFQUFNLHdIQUROO0tBSkQ7SUFNQSxRQUFBLEVBQ0M7TUFBQSxNQUFBLEVBQVEsa0JBQVI7TUFDQSxLQUFBLEVBQU8sRUFEUDtLQVBEO0lBU0EsT0FBQSxFQUNDO01BQUEsTUFBQSxFQUFRLGtCQUFSO01BQ0EsS0FBQSxFQUFPLEVBRFA7S0FWRDtJQVlBLGtCQUFBLEVBQ0M7TUFBQSxNQUFBLEVBQVEsa0JBQVI7TUFDQSxLQUFBLEVBQU8sRUFEUDtLQWJEO0lBZUEsZ0JBQUEsRUFDQztNQUFBLE1BQUEsRUFBUSxrQkFBUjtNQUNBLEtBQUEsRUFBTyxFQURQO0tBaEJEO0dBSkQ7OztBQXVCRCxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
